import {connect} from "react-redux";
import SearchComponent from "../components/SearchComponent";
import {searchSelector} from "../selectors";
import Meta from "../../_data/models/Meta";
import {search} from "../middlewares";

const mapStateToProps = (state, props) => {
    const search = searchSelector(state);

    return {
        meta: search.meta,
        loading: search.loading,
        loadingMessage: search.loadingMessage,
        results: search.results,
        view: search.view,
        noResultsFound: search.noSearchResultsFound
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadMore: (meta: Meta) => {
            if (meta && meta.hasNext())
                dispatch(search());
        }
    }
};

const SearchContainer = connect(mapStateToProps, mapDispatchToProps)(SearchComponent);
export default SearchContainer;


// WEBPACK FOOTER //
// ./app/client/search/containers/SearchContainer.tsx